import Vue from 'vue'
import App from './App.vue'
import store from './store'
import filters from './filters.js'

Vue.config.productionTip = false
filters.init();

new Vue({
  store,
  render: h => h(App),
  created() {
    this.$store.dispatch("init")

    // path change
    window.addEventListener("hashchange", function () {
      var parts = window.location.hash.split('?');
      var path = parts[0].substring(1);
      var urlParams = new URLSearchParams(parts[1]);
      var pathParams = Array.from(urlParams.keys())
        .reduce((r, i) => { r[i] = urlParams.get(i); return r; }, {})
      this.$store.commit("setPath", { path, pathParams });
    }.bind(this));

    // on exit
    window.addEventListener("beforeunload", function(event) {
      if (this.$store.getters.isChanged) {
        event.preventDefault();
        event.returnValue = "Máte neuložené změny";
      }
    }.bind(this));

    // start url
    if (window.location.hash.length > 0) {
      var parts = window.location.hash.split('?');
      var path = parts[0].substring(1);
      var urlParams = new URLSearchParams(parts[1]);
      var pathParams = Array.from(urlParams.keys())
        .reduce((r, i) => { r[i] = urlParams.get(i); return r; }, {})
      this.$store.commit("setPath", { path, pathParams });
    }
    else
      window.location.hash = "#dashboard";

    // refresh token
    setInterval(() => this.$store.dispatch("refreshToken"), 1000 * 60 * 15); // every 15 minutes
  }
}).$mount('#app')
